/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Model_Access_Restricted_BadgeInputs */



/**
* | output |
* | --- |
* | "{count} teams" |
*
* @param {Model_Access_Restricted_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_access_restricted_badge = /** @type {((inputs: Model_Access_Restricted_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Access_Restricted_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Teams`)
	return /** @type {LocalizedString} */ (`${i?.count} teams`)
});